import { createReducer } from 'typesafe-actions';

import { initialLocaleState } from './types';

import { convertToCrowdinLocale, getLocale } from '../../utils/i18next';

const localeReducer = (initialState = initialLocaleState) => {
  const computedInitialState = {
    ...initialState,
    language: convertToCrowdinLocale(getLocale()),
    isRtl: getLocale().substring(0, 2) === 'ar',
  };

  return createReducer(computedInitialState);
};

export default localeReducer;
